<template>
  <div>
    <RouterView></RouterView>
  </div>
</template>

<script>
import Vue from "vue";
import loginModal from "@/components/loginModal.vue";
export default {
  name: "App",
  globalData: {
    userInfo: {
      type: Object,
      default: () => {},
    },
  },
  async created() {
    // 每天强制更新代码
    const version = timestampToDate(new Date().getTime());
    console.log("version", version);
    if (version != localStorage.getItem("version")) {
      localStorage.setItem("version", version);
      window.location.href =
        window.location.href + "?t=" + new Date().getTime();
    }

    let firstLogin = localStorage.getItem("firstLogin");
    if (firstLogin) {
      localStorage.removeItem("firstLogin");
      return;
    } else {
      if (window.location.href.indexOf("login") == -1) {
        const ModalPage = Vue.extend(loginModal);
        const instance = new ModalPage();
        const notice = document.createElement("div");
        document.body.appendChild(notice);
        instance.$mount(notice);
      }
    }
  },
};
function timestampToDate(timestamp) {
  // 创建一个新的Date对象，将时间戳乘以1000（如果是秒级时间戳）
  const date = new Date(timestamp);

  // 获取年、月、日
  const year = date.getFullYear();
  // 月份从0开始，所以需要+1，然后确保两位数格式
  const month = String(date.getMonth() + 1).padStart(2, "0");
  // 获取日期，并确保两位数格式
  const day = String(date.getDate()).padStart(2, "0");

  // 返回YYYY-MM-DD格式的字符串
  return `${year}-${month}-${day}`;
}
</script>

<style lang="scss">
.mian {
  position: relative;
  width: 1400px;
  min-height: 600px;
  margin: 0 auto;
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 40px;
  box-sizing: border-box;
  animation: fadeIn 1s ease-in-out;
}

// 增加一个淡入淡出的动画
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
body {
  padding: 0;
  margin: 0;
  background: #f7f8fa;
  width: 100vw;
  overflow-x: hidden;
}

.border {
  border: 1px solid #e6e6e6;
}
.borderR {
  height: 20px;
  border-right: 2px solid #e6e6e6;
}

.borderB {
  border-bottom: 1px solid #e6e6e6;
}

.paddingB {
  padding-bottom: 20px;
}

.flex {
  display: flex;
}

.paddingT {
  padding-top: 20px;
}

.bgc {
  background: #ccc;
}
.xian {
  width: 3px;
  height: 29px;
  background: #f85559;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.pageTitle {
  width: 1400px;
  margin: 0 auto;
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  .sort {
    display: flex;
    font-weight: 400;
    font-size: 16px;
    color: #4a4a4a;
  }
  .active {
    color: #0d6fc2;
  }
  .currentLocation {
    font-weight: 400;
    font-size: 16px;
    color: #9b9b9b;
  }
}
.home .el-carousel__container {
  height: 100%;
}

.glass-effect {
  /* 设置边框圆角和阴影以实现毛玻璃效果 */
  border-radius: 10px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
  /* 使用filter的blur函数模糊内容 */
  filter: blur(2px);
  /* 将内容放置于模糊后的背景之上 */
  position: relative;
}

/* 使用伪元素来实现原内容的展示 */
.glass-effect::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: inherit;
  filter: blur(0);
  z-index: -1;
}
.pageTop1 {
  width: 100vw;
  // background: #fff;
}
.navbar {
  width: 1400px;
  margin: 0 auto;
  display: flex;
  align-items: flex-end;
  padding-bottom: 20px;
  .active {
    font-weight: bold;
    font-size: 16px;
    color: #0d6fc2;
    margin-right: 40px;
    position: relative;
    cursor: pointer;
    .line {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: 47px;
      height: 3px;
      bottom: -5px;
      background: #0d6fc2;
    }
  }
  .item {
    font-weight: normal;
    font-size: 16px;
    color: #4a4a4a;
    margin-right: 40px;
    cursor: pointer;
  }
}

.jrgwc {
  width: 107px;
  height: 30px;
  background: linear-gradient(180deg, #ffc000 0%, #f76b1c 100%);
  font-weight: normal;
  font-size: 14px;
  color: #ffffff;
  position: absolute;
  right: 0;
  bottom: 10px;
  border-radius: 5px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}
.jrwdkc {
  width: 107px;
  height: 30px;
  background: linear-gradient(180deg, #41a0f1 0%, #0a5b9f 100%) !important;
  font-weight: normal;
  font-size: 14px;
  color: #ffffff;
  right: 0;
  bottom: 10px;
  border-radius: 5px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}
.jrckkc {
  display: flex;
  justify-content: flex-end;
}
.el-loading-mask {
  background: rgba(255, 255, 255, 0.8);
}
.bg {
  background-image: url("@/assets/image/erjiyebu.png");
  height: 130px;
  background-size: 100% 100%;
}
.guanbi {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 15px;
  height: 15px;
  cursor: pointer;
}

.fontSize_20 {
  font-size: 20px !important;
}
.fontSzie_16 {
  font-size: 16px !important;
}
.daohangBg {
  background: linear-gradient(226deg, #307dd8, #43adae 50%, #f2ce31) !important;
}
.el-tabs__item {
  font-size: 16px !important;
  height: 60px !important;
  line-height: 60px !important;
}
.el-tabs__active-bar {
  height: 4px !important;
}
.el-tabs__nav-wrap::after {
  background-color: #78aeec !important;
  height: 2px !important;
}
.el-tabs__header {
  margin: 0 !important;
  margin-bottom: 20px !important;
}
.el-dialog {
  margin-top: 5vh !important;
}
.el-table--small {
  font-size: 16px !important;
}
.el-table__row {
  font-size: 14px !important;
}
</style>
